var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "organization-balance-table-cell" }, [
    _setup.billingType === "BillMeLater"
      ? _c("span", [
          _c("span", { staticClass: "statement-balance" }, [
            _vm._v("Statement: " + _vm._s(_setup.statementBalance)),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "current-balance" }, [
            _vm._v("Current: " + _vm._s(_setup.currentBalance)),
          ]),
        ])
      : _c("span", [_vm._v("N/A")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }